module.exports = __webpack_public_path__ + "static/media/qasim-hussain.d45c58ea.png";